import Vue from 'vue'
import Vuex from 'vuex'
import Crud from '../crud'
import Catalogs from '../catalogs'
import axios from 'axios'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  id: payload.id,
  branch_origin_id: payload.branch_origin_id,
  branch_destination_id: payload.branch_destination_id,
  comments: payload.comments
})
var crud = new Crud('Transfers', model)
var catalogs = new Catalogs()

Vue.use(Vuex)

const state = {
  ...crud.state,
  ...catalogs.state,
  catalog: {},
  tabSheet: [],
  convertedDetails: [],
  invalidValue: '',
  validProduct: false,
  transfer: {},
  transferDetails: [],
  transfers: []
}

const mutations = {
  ...crud.mutations,
  ...catalogs.mutations,
  SET_TRANSFER_AND_DETAILS (state, payload) {
    state.transfer = payload.data.transfer
    state.transferDetails = payload.data.details
  },
  SET_RECORDS (state, payload) {
    state.transfers = payload.data

    state.pagination = {
      currentPage: payload.meta.current_page,
      perPage: payload.meta.per_page,
      totalUsers: payload.meta.total,
      totalPages: payload.meta.last_page
    }
  },
  CONVERT_TO_ARRAY (state, payload) {
    var keys = [
      'code',
      'quantity'
    ]
    var i = 0
    var k = 0
    var obj = null
    var output = []

    for (i = 0; i < payload.length; i++) {
      obj = {}

      for (k = 0; k < keys.length; k++) {
        let value = payload[i][k].toString()
        if (keys[k] == 'quantity') {
          value = value.replaceAll(',', '')
          if (isNaN(value)) {
            state.invalidValue = value
            return false
          }
        } else if (keys[k] == 'code') value = value.toUpperCase()
        obj[keys[k]] = value
      }
      output.push(obj)
    }
    state.convertedDetails = output
    state.invalidValue = ''
    return state.convertedDetails
  },
  CLEAN_SPREAD_SHEET (state) {
    state.tabSheet = []
  },
  SET_PRODUCTS (state, payload) {
    state.transferDetails = []
    state.convertedDetails.forEach(function (element) {
      let product = payload.findIndex(u => u.code === element.code)
      if (product >= 0) {
        let data = {
          ...element,
          product_id: payload[product].id,
          quantity: parseFloat(element.quantity.replace(/[^0-9.]/g, '')).toFixed(2)
        }
        state.transferDetails.push(data)
      }
    })
  },
  SET_VALID_PRODUCT (state, payload) {
    state.validProduct = payload
  },
  CLEAN_SPREAD_SHEET (state) {
    state.tabSheet = []
  }
}

const actions = {
  ...crud.actions,
  ...catalogs.actions,
  cleanSpreadSheet ({ commit }, payload) {
    commit('CLEAN_SPREAD_SHEET')
  },
  convertToArrayOfObjects ({ commit }, payload) {
    commit('CONVERT_TO_ARRAY', payload)
  },
  async loadTransfer ({ commit }, payload) {
    try {
      const response = await axios.get(`transfers/${payload.id}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_TRANSFER_AND_DETAILS', response.data)
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async validateProduct ({ commit }, payload) {
    try {
      const response = await axios.put(`products/validate-by-codes`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: Vue.i18n.translate('errors.error_status', { attribute: response.status }), text: `${response.error} ${response.message}` }, { root: true })
      } else {
        if (response.data[0]) {
          commit('SET_PRODUCTS', response.data[1])
          commit('SET_VALID_PRODUCT', response.data[0])
        } else {
          commit('SET_VALID_PRODUCT', response.data[0])
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'products.not_found_title', text: 'Producto no encontrado: ' + response.data[2] }, { root: true })
        }
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: Vue.i18n.translate('errors.error_status', { attribute: 500 }), text: 'errors.server_error' }, { root: true })
    }
  },
  async updateProducts ({ commit }, payload) {
    try {
      const response = await axios.put(`transfers/${payload.id}/update-products`, { products: payload.products })
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: Vue.i18n.translate('errors.error_status', { attribute: response.status }), text: `${response.error} ${response.message}` }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.transfers', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        return 1
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: Vue.i18n.translate('errors.error_status', { attribute: 500 }), text: 'errors.server_error' }, { root: true })
      return 0
    }
  },
  async changeStatusToShipment ({ commit }, payload) {
    try {
      const response = await axios.put(`transfers/${payload.id}/shipment`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORD', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.transfers', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async changeStatusToApproved ({ commit }, payload) {
    try {
      const response = await axios.put(`transfers/${payload.id}/approved`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORD', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.transfers', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async changeStatusToCanceled ({ commit }, payload) {
    try {
      const response = await axios.put(`transfers/${payload.id}/canceled`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORD', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.transfers', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async changeStatusToPending ({ commit }, payload) {
    try {
      const response = await axios.put(`transfers/${payload.id}/pending`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORD', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.transfers', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  printTag ({ commit }, payload) {
    try {
      window.open(`${axios.defaults.baseURL}/transfers/${payload.id}/print-tags`)
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  sendErrorSameBranch ({ commit }, payload) {
    commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.title_same_branch', text: 'errors.selected_same_branch' }, { root: true })
  },
  sendAlertWithoutDetails ({ commit }, payload) {
    commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.title_without_products', text: 'errors.without_products' }, { root: true })
  },
  sendAlertExcelWithoutProducts ({ commit }, payload) {
    commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.title_without_products', text: 'errors.excel_without_products' }, { root: true })
  },
  sendAlertInvalidData ({ commit }, payload) {
    commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.invalid_data', text: Vue.i18n.translate('errors.invalid_value', { attribute: payload.value }) }, { root: true })
  }
}

const getters = {
  ...crud.getters,
  ...catalogs.getters,
  convertedDetails: state => state.convertedDetails,
  tabSheet: state => state.tabSheet,
  validProduct: state => state.validProduct,
  transfer: state => state.transfer,
  transfers: state => state.transfers,
  invalidValue: state => state.invalidValue
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
